import { createApi } from './core';
import { accountApi } from './services/account';
import { assessmentApi } from './services/assessment';
import { classroomApi } from './services/classroom';
import { clueyPlusApi } from './services/clueyPlus';
import { enrolmentApi } from './services/enrolment';
import { salesforceCaseApi } from './services/salesforceCase';
import { scheduleApi } from './services/schedule';
import { schoolTermApi } from './services/schoolTerm';
import { sessionApi } from './services/session';
import { staticApi } from './services/static';
import { studentApi } from './services/student';
import { subscriptionApi } from './services/subscription';
import { virtualCoachApi } from './services/virtualCoach';
import { voucherApi } from './services/voucher';

export const api = createApi.root({
  enrolment: enrolmentApi,
  session: sessionApi,
  schedule: scheduleApi,
  static: staticApi,
  account: accountApi,
  schoolTerm: schoolTermApi,
  assessment: assessmentApi,
  student: studentApi,
  virtualCoach: virtualCoachApi,
  classroom: classroomApi,
  voucher: voucherApi,
  salesforceCase: salesforceCaseApi,
  subscription: subscriptionApi,
  clueyPlus: clueyPlusApi,
});
